<div class="metrics-container" *ngIf="isMetricsCurrentValueValidAndNotNaN()">
  <div class="metrics-header">
    <div class="matrics-name">
      <div class="font-strong" [ngClass]="{ 'label-center': !showCurrentValue }">
        {{ metricsName }}
      </div>
      <span *ngIf="showCurrentValue">{{ currentValuelabel }}</span>
    </div>
    <div class="unit-value" *ngIf="showCurrentValue">
      <div class="font-strong">{{ metricsCurrentValue }}</div>
      <span>{{ metricsUnit }}</span>
    </div>
  </div>
  <div class="metrics-chart-container" *ngIf="dataSource?.length">
    <nrwl-spark-line-chart
      [chartOptions]="chartOptions"
      [dataSource]="dataSource"
      [units]="metricsUnit"
    ></nrwl-spark-line-chart>
  </div>
</div>
